<template>
    <div class="embedded-page">
        <router-view></router-view>
    </div>
</template>

<script>
import { DISCUSS_DATA_MANAGER } from '../../modules/data';
import { WS } from '../../modules/websocket';
import { DISCUSS_DOM } from '../../modules/dom';
import { UTILS } from '../../modules/utils';
export default {
    name: 'Embedded',
    computed: {
        commentHideName() {
            return this.$store.state.comment.hideName;
        },
        commentShareCode() {
            return this.$store.state.comment.shareCode;
        }
    },
    created: function() {
        var me = this,
            curPath = this.$router.history.current.path,
            curQuery = this.$router.history.current.query;
        console.log('Embedded------created', curPath, curQuery)
        switch(curPath) {
            case '/embedded/comment':
                this.initEmbeddedComment(curQuery);
                break;
            case '/embedded/discusslist':
                this.initEmbeddedDiscuss(curQuery);
                break;
            case '/embedded/discuss':
                this.initEmbeddedSendDiscuss(curQuery);
                break;
            case '/embedded/report':
                this.initEmbeddedReport(curQuery);
                break;
            case '/embedded/label':
                this.initEmbeddedLabel(curQuery);
                break;
            case '/embedded/labelmanage':
                this.initEmbeddedLabelManage(curQuery);
                break;
            default:
                break;
        }
    },
    methods: {
        /**
         * 初始化八字信息之后，跳转到初始化批盘逻辑
         */
        initEmbeddedComment(curQuery) {
            var me = this;
            this.$store.dispatch('embedded/initEmbeddedDetailInfo', {
                queryData: curQuery,
                cb: function(data) {
                    me.$store.state.detail.personInfo = data;
                    me.$store.dispatch('comment/initPiPan', data);
                    me.$store.dispatch('othercomment/getOtherPiPanList', data.id);
                    // 先重置，再初始化mini命盘的数据
                    me.$store.dispatch("minifatefortune/resetMiniData");
                    me.$store.dispatch('minifatefortune/initCommentMiniFateFortune', data);
                }
            });
        },
        /**
         * 初始化八字信息之后，跳转到初始化论盘列表逻辑
         */
        initEmbeddedDiscuss(curQuery) {
            var me = this;
            this.$store.dispatch('embedded/initEmbeddedDetailInfo', {
                queryData: curQuery,
                cb: function(data) {
                    // 保存一下token:::在论盘房间使用
                    me.$store.state.userData.token = curQuery.token;
                    me.$store.state.detail.personInfo = data;
                    me.$store.dispatch("discuss/initLunPanList", data);
                }
            })
        },
        /**
         * 初始化八字信息之后，跳转到发起论盘的逻辑
         */
        initEmbeddedSendDiscuss(curQuery) {
            var me = this;
            this.$store.dispatch('embedded/initEmbeddedDetailInfo', {
                queryData: curQuery,
                cb: function(data) {
                    // 保存一下token:::在论盘房间使用
                    me.$store.state.userData.token = curQuery.token;
                    me.$store.state.detail.personInfo = data;

                    me.$store.state.discuss.detailInfo = data;
                    var newTitle = DISCUSS_DATA_MANAGER.getNewLunPanTitle();
                    me.$store.dispatch('discuss/addNewLunPan', {
                        lunpanName: newTitle,
                        cb: function(lunpanData){
                            setTimeout(() => {
                                me.goToDiscussPage(data, lunpanData);
                            }, 100);
                        }
                    });
                }
            })
        },
        /**
         * 
         */
        goToDiscussPage(detailData, lunpanData){
            var me = this;
            // 先重置，再初始化mini命盘的数据
            this.$store.dispatch("minifatefortune/resetMiniData");
            this.$store.dispatch('minifatefortune/initCommentMiniFateFortune', detailData);
            WS.initWebSocket(lunpanData.rid, function() {
                // 初始化论盘数据:聊天记录列表:websocket登录之后再拉取列表数据
                me.$store.dispatch("discuss/initLunPan", {
                    lunpanData: lunpanData,
                    cb: function() {
                        // 设置微信分享配置
                        setTimeout(() => {
                            DISCUSS_DOM.updateDiscussPageStyle();
                            DISCUSS_DOM.updateDiscussFormStyle();
                        }, 200);
                    }
                });
            })
        },
        /**
         * 初始化八字信息之后，跳转到评测页的逻辑
         */
        initEmbeddedReport(curQuery) {
            console.log('initEmbeddedReport--------', curQuery)
            var me = this;
            this.$store.dispatch('embedded/initEmbeddedDetailInfo', {
                queryData: curQuery,
                cb: function(data) {
                    me.$store.state.detail.personInfo = data;
                    me.$store.dispatch('report/initReportAIConfig');
                    me.$store.dispatch('report/getReportInfo', {
                        detailInfo: data,
                        cb: function() {
                            console.log('initEmbeddedReport---------', data)
                        }
                    })
                }
            });

        },
        initEmbeddedLabel(curQuery) {
            var me = this;
            console.log('init-----', curQuery.from)
            switch(curQuery.from) {
                case 'updatelabel':
                    this.$store.dispatch('embedded/initEmbeddedDetailInfo', {
                        queryData: curQuery,
                        cb: function(data) {
                            me.$store.state.detail.personInfo = data;
                            me.$store.dispatch('label/initLabelList', {
                                cb: function() {
                                    me.$store.dispatch('label/initSelectedLabelFromDetail', data);
                                    me.$store.dispatch('label/updateComfirmedSelectedLabel');
                                }
                            });
                        }
                    });
                    break;
                case 'selectlabel':
                    var label = UTILS.getQueryString('label'),
                        remark = UTILS.getQueryString('remark');
                    curQuery = _.omit(curQuery, ['from', 'label', 'remark']);
                    this.$store.state.embedded.queryData = curQuery;
                    me.$store.dispatch('label/initLabelList', {
                        cb: function() {
                            me.$store.dispatch('label/initSelectedLabelFromDetail', {
                                label: label, remark: remark
                            });
                            me.$store.dispatch('label/updateComfirmedSelectedLabel');
                        }
                    });
                    break;
                case 'searchlabel':
                    curQuery = _.omit(curQuery, ['from']);
                    this.$store.state.embedded.queryData = curQuery;
                    this.$store.dispatch('label/initLabelList');
                    this.$store.dispatch('label/updateComfirmedSelectedLabel');
                    break;
                default:
                    break;
            }
        },
        initEmbeddedLabelManage(curQuery) {
            curQuery = _.omit(curQuery, ['from', 'id', 'label', 'remark']);
            this.$store.state.embedded.queryData = curQuery;
            this.$store.dispatch('label/initLabelList');
            this.$store.dispatch('label/updateComfirmedSelectedLabel');
        }
    }
}
</script>